<div class="image_upload_container nis_model" style="">

    <div class="modal-header" style="height:44px;">
        <h4>Upload File</h4>
    </div>

    <div class="modal-body" style="height:auto;">



            <div class="icon_dummy" *ngIf="showDummyImage">
                <i class="fa fa-file-image-o" aria-hidden="true"></i>
            </div>

            <div class="w100" *ngIf="showPDFFileIcon">
                <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer>
            </div>

            <ngx-super-croppie
                *ngIf="enableImageCropper"
                #ngxSuperCroppie
                [croppieOptions]="croppieOptions"
                [url]="uploadedFileBase64Data"
                [orientation]="orientation"
                [zoom]="zoom"
                [resultOptions]="resultOptions"
                (result)="updateCroppedImage($event)"
            ></ngx-super-croppie>




    </div>
    <div class="file_upload1" >
        <span class="fileUpload upload_btn ">
            <span class="upl" id="upload"><i class="fa fa-upload" aria-hidden="true"></i></span>
            <input type="file" [accept]="requestObject.allowFileTypeList" (change)="uploadFile($event)" class="upload up"/>
        </span>
    </div>

    <div class="instructionss">
        <div class="element">
            <h4>Note:</h4>
            <p>1. Image size should be less than 1MB.</p>
            <ng-container *ngIf="requestObject.isProfilePicUploaded === true">
                <p>2. Must be white background.</p>
                <p>3. Must contain face.</p>
            </ng-container>
            <p *ngIf="requestObject.isProfilePicUploaded === false">2. PDF size should be less than 1MB.</p>
        </div>
    </div>

    <div class="modal-footer" style="position:fixed;bottom:0;width:100%;">
        <button type="button" class="btn" (click)="confirm()">OK</button>
        <button type="button" class="back_btn" (click)="cancel()">Cancel</button>
    </div>

</div>
